import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IApplicationDocuments } from '../../models/application-menu/application-document';
import { IInspectionCorrectiveAction } from '../../models/inspection/inspection-corrective-action';
import { ISubmitInspectionResult } from '../../models/inspection/SubmitInspectionResult';
import { environment } from '@env/environment';
import { IInspectionSummaryViewModel } from 'app/models/reports/reports';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({
  providedIn: 'root',
})

export class InspectionService {
  private api: string = environment.privateApi + 'Assessment/';
  private reportApi: string = environment.privateApi + 'Reports/';

  constructor(private http: HttpClient) {}

  getInspectionDocuments(appId: number): Observable<IApplicationDocuments[]> {
    return this.http.get<any>(this.api + 'getInspectionDocs/' + appId , httpOptions);
  }

  getInspectionCAs(appId: number): Observable<IInspectionCorrectiveAction[]> {
    return this.http.get<IInspectionCorrectiveAction[]>(this.api + 'getInspectionCas/' + appId, httpOptions);
  }

  uploadDocuments(files: FormData, appId: number): Observable<boolean> {
    return this.http.post<boolean>(this.api + 'uploadDocuments/' + appId, files);
  }

  downloadDocument(fileId: number, appId: number): Observable<Blob> {
    return this.http.get<Blob>(this.api + 'downloadDocument/' + fileId + '/' + appId, { responseType: 'blob' as 'json' });
  }

  deleteDocument(documentId: number, appId: number): Observable<any> {
    return this.http.delete<any>(this.api + 'deleteDocument/' + documentId + '/' + appId, httpOptions);
  }

  saveCorrectiveAction(ca: IInspectionCorrectiveAction): Observable<boolean> {
    return this.http.post<boolean>(this.api + "correctiveActionResponse", ca, httpOptions);
  }

  submitInspection(appId: number): Observable<ISubmitInspectionResult> {
    return this.http.post<ISubmitInspectionResult>(this.api + "submitInspection/" + appId, httpOptions);
  }

  getInspectionSummary(appId: number, labId: number): Observable<IInspectionSummaryViewModel> {
    return this.http.get<IInspectionSummaryViewModel>(this.reportApi + 'getInspectionSummary/' + appId + '/' + labId, httpOptions);
  }

  getInspectionStatus(appId: number): Observable<string> {
    return this.http.get(this.api + 'getInspectionStatus/' + appId, {responseType: 'text'});
  }
}
